//Libraries
import {FC} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';

//Typing
import {IAIRecord} from "../../types/org/ai/aiInterface";
import {APP_URLS} from 'src/constants';

//Components
import {ProfileEditForm} from './operations/profileEditForm';
import {Loader} from 'src/generic/component';

/**
 * This component is only responsible for extracting
 * the org and ai data from the navigation and instantiating
 * the ProfileEditForm.
 */
export const ProfileEditPage: FC = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const state = location.state as any;
    const record = state?.record as IAIRecord;

    if (record) {
        return <ProfileEditForm onComplete={() => {
            navigate(APP_URLS.PROFILE, {
                state: {
                    aiCode: record.ai.aiCode,
                    orgId: record.org.orgId,
                    type: 'ai'
                }
            });
        }} onClose={() => {
            navigate(APP_URLS.PROFILE, {
                state: {
                    aiCode: record.ai.aiCode,
                    orgId: record.org.orgId,
                    type: 'ai'
                }
            });
        }} record={record}></ProfileEditForm>;
    } else {
        return <Loader></Loader>;
    }
};